import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom";
import { EmptyString, FormTypeEdit, InsertDateFormat, MdrOffUs, MdrOnUs, MdrQrisOffUs, MdrQrisOnUs, PageSizeOptions } from "utils/Constant"
import moment from "moment";
import Select from 'react-select'
import DatePicker from "components/Input/DatePicker";
import { addSpaceEvery4, CheckResponse, decimal, money, removeNonNumeric } from "utils/helpers";
import Dropdown from "components/Input/Dropdown";
import RevisionIcon from "assets/icon/RevisionIcon";
import { useCallApi } from "api/apiHooks";
import { CreditCardDetailCard, GridDeleteButton, MainBodyCard, PagesTitle } from "components/Cards";
import TransferIcon from "assets/icon/TransferIcon";
import { useModal } from "utils/context/ModalContext";
import { TransactionService } from "services/TransactionService/TransactionService";
import DataTable from "components/DataTable";
import PrimaryButton from "components/Button/PrimaryButton";
import { useAuth } from "utils/context/AuthContext";
import { useVariable } from "utils/context/VariableContext";

export default function Transaction(){
    let navigate = useNavigate()

    const debounceRef = useRef(null)
    const minuteRef = useRef(null)

    const { accessToken } = useAuth()
    const { edcOptions, locationId, isAdmin } = useVariable()

    const { fetchBeneficiaryList, fetchTransactionCustomerCardList, fetchCustomerCardById, fetchEdcList } = useCallApi()
    const { fetchTransactionList, fetchInsertTransaction, fetchDeleteTransaction } = TransactionService()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    const [frequentCustomer, setFrequentCustomer] = useState(JSON.parse(localStorage.getItem('FrequentCustomer')) || [])

    const [transactionList, setTransactionList] = useState([])
    const [cardNumber, setCardNumber] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [expired, setExpired] = useState(EmptyString)
    const [vcc, setVcc] = useState(EmptyString)
    const [mdr, setMdr] = useState(EmptyString)
    const [mdrQris, setMdrQris] = useState(EmptyString)
    const [mdrPl, setMdrPl] = useState(EmptyString)
    const [mdrPlQris, setMdrPlQris] = useState(EmptyString)
    const [dueDate, setDueDate] = useState(EmptyString)
    const [cardLimit, setCardLimit] = useState(EmptyString)
    const [cardType, setCardType] = useState(EmptyString)
    const [customerCard, setCustomerCard] = useState(EmptyString)
    const [customerCardOptions, setCustomerCardOptions] = useState([])
    const [amount, setAmount] = useState(EmptyString)
    const [trMdr, setTrMdr] = useState(EmptyString)
    const [netto, setNetto] = useState(EmptyString)
    const [transactionType, setTransactionType] = useState('OffUs');
    const [edc, setEdc] = useState(EmptyString)
    // const [edcOptions, setEdcOptions] = useState([])
    const [transactionDate, setTransactionDate] = useState(new Date())
    const [pageSize, setPageSize] = useState(PageSizeOptions[0].value)
    const [edcType, setEdcType] = useState(EmptyString)
    const [qrisHour, setQrisHour] = useState(moment(new Date()).format("HH"))
    const [qrisMinute, setQrisMinute] = useState(moment(new Date()).format("mm"))
    const [paymentmethod, setPaymentMethod] = useState('1')
    const [paymentmethodOptions, setPaymentMethodOptions] = useState([
        { label: 'Transfer', value: '1' },
        { label: 'Cash', value: '2' },
        { label: 'Cash & Transfer', value: '3' },
        { label: 'Lainnya', value: '4' }
    ])
    const [transferAmount, setTransferAmount] = useState(EmptyString)
    const [cashAmount, setCashAmount] = useState(EmptyString)
    const [remark, setRemark] = useState(EmptyString)
    const [beneficiaryId, setBeneficiaryId] = useState(EmptyString)
    const [beneficiaryOptions, setBeneficiaryOptions] = useState([])
    const [transactionTypeOptions, setTransactionTypeOptions] = useState([
        { label: 'Credit On Us', value: 'OnUs' },
        { label: 'Credit Off Us', value: 'OffUs' },
        { label: 'Credit Amex', value: 'Amex' },
        { label: 'Debit On Us', value: 'DebitOnUs' },
        { label: 'Debit Off Us', value: 'DebitOffUs' },
        { label: 'Qris On Us', value: 'QrisOnUs' },
        { label: 'Qris Off Us', value: 'QrisOffUs' }
    ])
    const [calculationType, setCalculationType] = useState('Kotor')
    const [reffNo, setReffNo] = useState('')
    const [customerId, setCustomerId] = useState('')
    const [customerCardId, setCustomerCardId] = useState('')
    const [showCvv, setShowCvv] = useState(false)
    const [selectedCustomerCard, setSelectedCustomerCard] = useState({})

    // OPTIONS
    const [resellerOptions, setResellerOptions] = useState([])


    // GRID
    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center"
        },
        {
            key: "transactionDate",
            header: "Tanggal",
            render: (data) => moment(data.transactionDate).format('DD MMM YYYY')
        },
        {
            key: "bankCode",
            header: "Bank",
            render: (data) => data.bankCode + ' - ' + data.vendorName
        },
        {
            key: "cardNumber",
            header: "No Kartu",
            render: (data) => addSpaceEvery4(data.cardNumber)
        },
        {
            key: "customerName",
            header: "Nama Pelanggan",
            render: (data) => data.customerName.toUpperCase()
        },
        {
            key: "mdr",
            header: "Charge",
        },
        {
            key: "amount",
            header: "Gesek",
            render: (data) => 'Rp ' + money(String(Math.floor(data.amount))),
        },
        {
            key: "netto",
            header: "Cash",
            render: (data) => 'Rp ' + money(String(Math.floor(data.netto))),
        },
        {
            key: "edc",
            header: "EDC",
            render: (data) => data.edcBank + ' - ' + data.edcName.toUpperCase()
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <div className="flex gap-2">
                    <GridDeleteButton isActive={row.status} onClick={() => deleteBtnClick(row.transactionId, row.status)} size="w-3" />
                </div>
            ),
        },
    ]

    // Handlers

    const customerCardOnInput = (e) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current)
        }

        debounceRef.current = setTimeout(() => {
            fetchTransactionCustomerCardList(e, '', 0, 0, '1', 50, 0).then((res) => {
            if (!res) return

            if (res.data.listData.length > 0) {
                let data = res.data.listData
                let tempArray = []

                for (let i = 0; i < data.length; i++) {
                    tempArray.push({
                        label:
                        addSpaceEvery4(data[i].cardNumber) +
                        " (" +
                        data[i].bankCode.trim() +
                        ") - " +
                        data[i].customerName,
                        value: String(data[i].customerCardId),
                    })
                }

                setCustomerCardOptions(tempArray)
            }
            })
        }, 500) // delay here (ms)
    }
    const beneficiaryOnInput = (e) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current)
        }

        debounceRef.current = setTimeout(() => {
            fetchBeneficiaryList('', e, 0, '1', 100, 0).then((res) => {
                if (!CheckResponse(res)) {
                    showFail(res.message)
                    return
                }

                if (res.data.listData.length > 0){
                    let data = res.data.listData
                    let tempArray = []

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].accountName + " - " + data[i].bankCode + " (" + data[i].accountNo + ")", value: String(data[i].beneficiaryId) })
                    }

                    setBeneficiaryOptions(tempArray)
                }
            })
        }, 500) // delay here (ms)
    }

    const customerCardChange = (e) => {
        showLoading()

        setCustomerCard(e)
        
        fetchCustomerCardById(e.value).then((res) => {
            if (!res) return 

            const data = res.data

            setCardNumber(data.cardNumber)
            setName(data.customerName)
            setExpired(data.expiredMonth === EmptyString ? "-" : data.expiredMonth + " / " + data.expiredYear ===  EmptyString ? "-" : data.expiredYear)
            setVcc(data.vcc === EmptyString ? "-" : data.vcc)
            setMdr(data.mdr)
            setMdrQris(data.mdrQris)
            setMdrPl(data.mdrPl)
            setMdrPlQris(data.mdrPlQris)
            setDueDate(data.dueDate)
            setCardLimit(money(data.cardLimit))
            setCardType(data.bankName + " " + data.cardVendorName)
            setCustomerId(data.customerId)
            setCustomerCardId(data.customerCardId)
            setSelectedCustomerCard(data)

            if (isAdmin) {
                if (edc !== '') {
                    if (edc.type === '1' || edc.type === '3') {
                        // EDC/ONLINE
                        setTrMdr(data.mdr)
                        fCalculateNetto(amount, data.mdr)
                    }

                    if (edc.type === '2') {
                        // QRIS
                        setTrMdr(data.mdrQris)
                        fCalculateNetto(amount, data.mdrQris)
                    }
                } else {
                    setTrMdr(data.mdr)
                    fCalculateNetto(amount, data.mdr)
                }
            } else {
                setTrMdr(data.mdr)
                fCalculateNetto(amount, data.mdr)
            }
            

            hideLoading()
        })
    }
    const edcChange = (e) => {
        setEdc(e)
        
        if (isAdmin) {
            if (customerCard === '') return

            if (e.type === '1' || e.type === '3') {
                // EDC/ONLINE
                setTrMdr(mdr)
            }

            if (e.type === '2') {
                // QRIS
                setTrMdr(mdrQris)
            }

            console.log(e)
        }
    }
    const transactionDateChange = (e) => {
        if (e === null) {
            setTransactionDate(new Date())
        }else{
            setTransactionDate(e)
        }
    }
    const amountChange = (e) => {
        fCalculateNetto(e.target.value, trMdr)
        setAmount(money(e.target.value))        
    }
    const nettoChange = (e) => {
        fCalculateAmount(e.target.value, trMdr)
        setNetto(money(e.target.value))   
    }
    const trMdrChange = (e) => {
        let inputValue = e.target.value

        if (inputValue !== EmptyString){
            let number = parseInt(inputValue)
            if (number > 100){
                
            }else{
                setTrMdr(decimal(e.target.value))
            }
        }else{
            setTrMdr(decimal(e.target.value))
        }
        
        
    }
    const trMdrKeyUp = (e) => {
        fCalculateNetto(amount, e.target.value)
    }
    const pageSizeChange = (e) => {
        setPageSize(e.value)
    }
    
    function fCalculateNetto(amount, mdrInput){
        let xAmount = amount === EmptyString ? 0 : parseFloat(amount.replaceAll(",", ""))
        let xMdr = mdrInput === EmptyString ? 0 : parseFloat(mdrInput)
        let xNetto = xAmount - (xAmount * xMdr / 100)
        // ✅ round down to nearest 1000
        let roundedNetto = Math.floor(xNetto / 1000) * 1000

        setNetto(money(parseInt(xNetto)))
        setTransferAmount(money(parseInt(roundedNetto)))
    }
    function fCalculateAmount(netto, mdrInput) {
        let xNetto = netto === EmptyString ? 0 : parseFloat(netto.replaceAll(",", ""));
        let xMdr = mdrInput === EmptyString ? 0 : parseFloat(mdrInput);

        // Calculate gross amount before MDR
        let xAmount = xNetto / (1 - xMdr / 100);

        // Round up to nearest 1000
        let roundedAmount = Math.ceil(xAmount / 1000) * 1000;

        setAmount(money(parseInt(roundedAmount)));
    }
   
    const saveBtnClick = () => {
        if (validation()){
            showLoading()

            let trxType = ""

            if (transactionType === MdrOnUs){
                trxType = "1"   // On Us
            } else if (transactionType === MdrOffUs){
                trxType = "2"   // Off Us
            } else if (transactionType === MdrQrisOnUs){
                trxType = "3"   // Qris On Us
            } else if (transactionType === MdrQrisOffUs){
                trxType = "4"   // Qris Off Us
            } else if (transactionType === 'Amex'){
                trxType = "5"   // Credit Amex
            } else if (transactionType === 'DebitOnUs'){
                trxType = "6"   // Debit On Us
            } else if (transactionType === 'DebitOffUs'){
                trxType = "7"   // Debit Off Us
            } 

            let time = qrisHour + ":" + qrisMinute

            fetchInsertTransaction(
                moment(transactionDate).format(InsertDateFormat), 
                customerCard.value, 
                edc.value, 
                edc.mdrOff, 
                edc.mdrOn, 
                edc.mdrQrisOn, 
                edc.mdrQrisOff, 
                edc.mdrCreditAmex,
                edc.mdrDebitOnUs,
                edc.mdrDebitOffUs,
                trxType, 
                amount.replaceAll(',', ''), 
                trMdr, 
                netto.replaceAll(',', ''), 
                parseInt(locationId), 
                time, 
                paymentmethod, 
                transferAmount === EmptyString ? 0 : transferAmount.replaceAll(",", ""),
                paymentmethod === "2" ? netto.replaceAll(",", "") : (cashAmount === EmptyString ? 0 : cashAmount.replaceAll(",", "")),
                remark, 
                (beneficiaryId !== null && beneficiaryId !== EmptyString) ? beneficiaryId.value : 0,
                reffNo
            ).then((res) => {
                if (!res) return

                showSuccess({
                    onSuccess: () => {
                        setAmount(EmptyString)
                        setNetto(EmptyString)
                        setTransferAmount(EmptyString)
                        setCashAmount(EmptyString)
                        setRemark(EmptyString)
                        setQrisHour(moment(new Date()).format("HH")) 
                        setQrisMinute(moment(new Date()).format("mm"))
                        if (isAdmin) {
                            generateRefNumber()
                        } else {
                            setReffNo('')
                        }
                    }
                })

                fetchTransactionList(new Date(), new Date(), '', '', 0, '1', pageSize, 0, '', parseInt(locationId)).then((res) => {
                    hideLoading()

                    if (!res) return

                    setTransactionList(res)
                })
            }).finally(() => {
                hideLoading()
            })
        }
    }
    const deleteBtnClick = async (id, status) => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            try {
                fetchDeleteTransaction(id, status).then((res) => {
                    if (!res) return

                    fetchTransactionList(new Date(), new Date(), '', '', 0, '1', pageSize, 0, '', parseInt(locationId)).then((res) => {
                        if (!res) return

                        setTransactionList(res)
                    })
                })
            } finally {
                hideLoading()
            }
        }
    }
    const previousDayClick = async () => {
        setTransactionDate(moment(transactionDate).subtract(1, 'day'))
    }
    const todayClick = async () => {
        setTransactionDate(new Date())
    }

    const validation = () => {
        let isValid = true
        let message = EmptyString

        if (paymentmethod === EmptyString){
            isValid = false
            message = "Payment Method must be selected"
        } else {
            if (paymentmethod === '1' || paymentmethod === '3'){
                if (beneficiaryId === EmptyString || beneficiaryId === null){
                    isValid = false
                    message = "Beneficiary must be selected"
                }
            }
        }

        // if (qrisHour === EmptyString || qrisMinute === EmptyString){
        //     isValid = false
        //     message = "Transaction Time is required"
        // }

        if (reffNo.length < 6) {
            isValid = false
            message = "Reff No harus 6 digit!"
        }

        if (reffNo === '') {
            isValid = false
            message = "Reff No tidak boleh kosong"
        }

        if (customerCard === EmptyString || customerCard === null){
            isValid = false
            message = "Customer Card is required"
        }

        if (edc === EmptyString || edc === null || edc === 0 || typeof edc.value === 'undefined'){
            isValid = false
            message = "EDC is required"
        }

        if (amount === EmptyString){
            isValid = false
            message = "Jumlah Gesek is required"
        }

        if (locationId === ""){
            isValid = false
            message = "You have no location access, please contact administrator."
        }

        if (isValid){
            return true
        }else{
            showFail(message)

            return false
        }
    }

    const generateRefNumber = () => {
        const random = Math.floor(1000 + Math.random() * 9000)
        setReffNo(`RN${random}`)
    }

    useEffect(() => {
        const onLoad = async () => {
            if (accessToken === null) {
                return
            }
            
            if (locationId === ""){
                showFail("You have no location access, please contact administrator.")

                return
            }

            if (isAdmin) {
                generateRefNumber()
            }
        }

        onLoad()        
    }, [])

    useEffect(() => {
        const transfer = parseInt(netto.replaceAll(',', '') === '' ? 0 : netto.replaceAll(',', ''))
        const cash = parseInt(cashAmount.replaceAll(',', '') === '' ? 0 : cashAmount.replaceAll(',', ''))
        const nettTransfer = transfer - cash
        const rounded = Math.floor(nettTransfer / 1000) * 1000

        setTransferAmount(money(rounded))
    }, [cashAmount])

    useEffect(() => {
        if (locationId !== null && locationId !== "" && locationId !== "0"){
            fetchTransactionList(new Date(), new Date(), '', '', 0, '1', pageSize, 0, '', parseInt(locationId)).then((res) => {
                if (!res) return

                setTransactionList(res)
            })
        }
    }, [pageSize, locationId])

    return(
        <MainBodyCard>
            <PagesTitle title={'Transaction'} />
            
            <div className="flex flex-col md:flex-row mt-2 gap-4">
                {/* Customer Info */}
                <div className="md:w-6/12 xl:max-w-[500px] xl:min-w-[500px] sm:border rounded-md sm:p-4 w-full sm:bg-white flex flex-col sm:shadow-md">
                    <div className="hidden sm:block">
                        <span className="font-semibold text-md sm:text-xl">Enter Card Number</span>
                        <hr className="mt-2" />
                    </div>
                    <div className="sm:mt-4 mb-2">
                        <div>
                            <Select className="text-base sm:text-sm" options={customerCardOptions} onInputChange={customerCardOnInput} onChange={customerCardChange} />
                        </div>
                    </div>

                    {(locationId === '6' && isAdmin) && (
                        // resellerOptions
                        frequentCustomer.map((data) => (
                            <div className={`border rounded-lg p-2 cursor-pointer mb-2 
                                ${customerCard.value === data.value ? 'bg-black text-white' : 'bg-white text-black'}`}
                                onClick={(e) => {
                                    customerCardChange(data)
                                    setCustomerCard(data)
                                }}
                            >
                                <span>{data.customerName}</span>
                            </div>
                        ))
                    )}

                    <div className="mt-4 flex flex-col gap-4 text-sm">
                        <div className="hidden sm:block">
                            <CreditCardDetailCard title='Card Number'>
                                <span>{addSpaceEvery4(cardNumber)}</span>
                            </CreditCardDetailCard>
                        </div>                        
                        <CreditCardDetailCard title='Name'>
                            <span>{name}</span>
                        </CreditCardDetailCard>
                        <div className="hidden sm:block">
                            <CreditCardDetailCard title='Expired'>
                                <span>{expired}</span>
                            </CreditCardDetailCard>
                        </div>
                        <div className="hidden sm:block">
                            <CreditCardDetailCard title='VCC'>
                                <span>{showCvv ? vcc : '***'}</span>
                            </CreditCardDetailCard>
                        </div>

                        <CreditCardDetailCard title='MDR'>
                            <span>{mdr}</span>
                        </CreditCardDetailCard>

                        <CreditCardDetailCard title='MDR QRIS'>
                            <span>{mdrQris}</span>
                        </CreditCardDetailCard>

                        <div className="hidden sm:flex flex-col gap-4">
                            <CreditCardDetailCard title='MDR PL'>
                                <span>{mdrPl}</span>
                            </CreditCardDetailCard>

                            <CreditCardDetailCard title='MDR PL QRIS'>
                                <span>{mdrPlQris}</span>
                            </CreditCardDetailCard>

                            <CreditCardDetailCard title='Card Type'>
                                <span>{cardType}</span>
                            </CreditCardDetailCard>

                            <CreditCardDetailCard title='Tgl JT'>
                                <span>{dueDate}</span>
                            </CreditCardDetailCard>

                            <CreditCardDetailCard title='Limit'>
                                <span>{cardLimit}</span>
                            </CreditCardDetailCard>
                        </div>
                        

                        {customerId !== '' && (
                            <div className="flex gap-4">
                                <PrimaryButton title='Lihat detail customer' onClick={() => navigate("/customer/view?customerId=" + customerId)} />
                                <PrimaryButton title='Lihat detail kartu' onClick={() => navigate("/customer-card/form?formType=" + FormTypeEdit + "&customerCardId=" + customerCardId)} />
                            </div>
                        )}
                        
                    </div>
                </div>

                {/* Transaction Form */}
                <div className="md:w-full sm:border rounded-md sm:p-4 w-full bg-white flex flex-col sm:shadow-md">
                    <div>
                        <span className="font-semibold text-xl">Transaction Form</span>
                        <hr className="mt-2" />
                    </div>
                    <div className="mt-4 flex flex-col gap-4 text-sm">
                        <Card title="Tanggal Transaksi" width='w-max'>
                            <div className="flex gap-2">
                                <DatePicker className="w-full sm:w-72 h-10" value={transactionDate} onChange={transactionDateChange} />
                                <button className="hidden sm:block button" onClick={previousDayClick}>H-1</button>
                                <button className="hidden sm:block button" onClick={todayClick}>H</button>
                            </div>
                        </Card>

                        <Card title="Mesin">
                            <Select className="text-base sm:text-sm" options={edcOptions} value={edc} onChange={edcChange} />
                        </Card>

                        <div className="flex flex-col sm:flex-row sm:items-center">
                            <div className="w-48 xl:min-w-48">
                                <span className="text-sm">Tipe</span>
                            </div>
                            <div className="px-2 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="flex flex-wrap gap-2 items-center w-full sm:w-72 xl:w-full">
                                {transactionTypeOptions?.map((data, i) => {
                                    return (
                                        <button
                                            className={` 
                                                border rounded-full px-3 py-1 text-xs
                                                ${transactionType === data.value ? 'bg-black text-white' : 'bg-white text-black'}`}
                                            onClick={() => { setTransactionType(data.value) }}
                                            key={i}
                                        >
                                            { data.label }
                                        </button>
                                    )
                                })}
                            </div>
                        </div>

                        <div className="hidden">
                            <Card title="Waktu Transaksi">
                                <div className="flex">
                                    <div className="flex items-center gap-2">
                                        <div className="w-14">
                                            <input className="input" value={qrisHour} 
                                                onChange={(e) => {
                                                    const value = removeNonNumeric(e.target.value);
                                                    if (value.length <= 2) {
                                                        setQrisHour(value);

                                                        if (value.length === 2) {
                                                            minuteRef.current?.focus();
                                                        }
                                                    }
                                                }}
                                                onFocus={() => setQrisHour('')}
                                                placeholder="HH" />
                                        </div>
                                        <span>:</span>
                                        <div className="w-14">
                                            <input className="input" value={qrisMinute} ref={minuteRef}
                                                onChange={(e) => e.target.value.length > 2 ? null : setQrisMinute(removeNonNumeric(e.target.value))} 
                                                onFocus={() => setQrisMinute('')}
                                                placeholder="MM" />
                                        </div>
                                    </div>

                                    <div className="ml-4">
                                        <button className="bg-black p-2 rounded-md"
                                            onClick={() => { 
                                                setQrisHour(moment(new Date()).format("HH")) 
                                                setQrisMinute(moment(new Date()).format("mm")) 
                                            }}
                                        >
                                            <RevisionIcon className="w-6 fill-white" />
                                        </button>
                                    </div>
                                </div>    
                            </Card>
                        </div>

                        {/* Ref Number */}
                        {!isAdmin && (
                            <Card title='Ref No'>
                                <div className="flex justify-between">
                                    <input className="border px-2 py-2 rounded-lg w-24" type="text" value={reffNo} onChange={(e) => setReffNo(e.target.value.toUpperCase())} maxLength={6} placeholder="Reff No (6 digit)" />
                                    <button className={`text-white px-2 rounded-lg ${calculationType === "Bersih" ? 'bg-black' : 'bg-gray-300'}`}
                                        disabled={calculationType === "Bersih" ? false : true}
                                        onClick={() => setCalculationType("Kotor")}
                                    >
                                        <span className="text-xs">Gesek Kotor</span>
                                    </button>
                                    <button className={`text-white px-2 rounded-lg ${calculationType === "Bersih" ? 'bg-gray-300' : 'bg-black'}`}
                                        disabled={calculationType === "Bersih" ? true : false}
                                        onClick={() => setCalculationType("Bersih")}
                                    >
                                        <span className="text-xs">Gesek Bersih</span>
                                    </button>
                                </div>
                            </Card>
                        )}
                        
                        {/* Amount */}
                        <Card title='Jumlah Gesek'>
                            <input className="input text-base sm:text-sm" type="text" inputMode="numeric" value={amount} 
                                disabled={calculationType === 'Bersih' ? true : false} 
                                onChange={amountChange} placeholder="Jumlah Gesek" />
                        </Card>

                        {/* MDR */}
                        <Card title='MDR'>
                            <input className="input text-base sm:text-sm" type="text" value={trMdr} onChange={trMdrChange} onKeyUp={trMdrKeyUp} placeholder="MDR" />
                        </Card>

                        {/* Netto */}
                        <Card title='Jumlah Uang Diterima'>
                            <input className="input text-base sm:text-sm" value={netto} 
                                onChange={nettoChange}
                                disabled={calculationType === 'Bersih' ? false : true} 
                                placeholder="Jumlah Uang Diterima" 
                            />
                        </Card>

                        {/* Payment Method */}
                        <div className="flex flex-col sm:flex-row sm:items-center">
                            <div className="xl:min-w-48 w-48 text-sm">
                                <span>Metode Pembayaran</span>
                            </div>
                            <div className="px-2 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72 xl:w-full">
                                <div className="flex gap-2 flex-wrap">
                                    {paymentmethodOptions.map((data, i) => {
                                        return(
                                            <button
                                                className={` 
                                                    border rounded-full px-3 py-1 text-xs
                                                    ${paymentmethod === data.value ? 'bg-black text-white' : 'bg-white text-black'}`}
                                                onClick={() => { setPaymentMethod(data.value) }}
                                                key={i}
                                            >
                                                { data.label }
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>

                        {(paymentmethod === '1' || paymentmethod === '3') && (
                            <div className="flex flex-col gap-4">
                                <Card title='Jumlah Uang Ditransfer'>
                                    <div className="flex gap-2">
                                        <input className="input text-base sm:text-sm" value={transferAmount} onChange={(e) => setTransferAmount(money(e.target.value))} disabled={isAdmin ? false : true} placeholder="Jumlah uang ditransfer" />
                                        <button className="bg-black rounded-lg px-3"
                                            onClick={() => {
                                                if (paymentmethod === '3') {
                                                    const transfer = parseInt(netto.replaceAll(',', ''))
                                                    const cash = parseInt(cashAmount.replaceAll(',', ''))
                                                    const nettTransfer = transfer - cash

                                                    setTransferAmount(money(nettTransfer))
                                                } else {
                                                    setTransferAmount(netto)
                                                }
                                            }}
                                        >
                                            <TransferIcon className="fill-white w-5" />
                                        </button>
                                    </div>
                                </Card>

                                {paymentmethod === '3' && (
                                    <Card title='Jumlah Uang Cash'>
                                        <input className="input text-base sm:text-sm" value={cashAmount} onChange={(e) => setCashAmount(money(e.target.value))} disabled={false} />
                                    </Card>
                                )}

                                {/* Beneficiary Account */}
                                <div className="flex">
                                    <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                        <div className="w-48">
                                            <span className="text-sm">Beneficiary Account</span>
                                        </div>
                                        <div className="px-2 hidden sm:block">
                                            <span>:</span>
                                        </div>
                                        <div className="w-full sm:w-72">
                                            <Select className="text-base sm:text-sm" options={beneficiaryOptions} onInputChange={beneficiaryOnInput} value={beneficiaryId} onChange={setBeneficiaryId} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {!isAdmin && (
                            <Card title='Transfer Remark'>
                                <input className="input" value={remark} onChange={(e) => setRemark(e.target.value)} disabled={false} />
                            </Card>
                        )}
                       
                        <div className="flex gap-2 items-center">
                            <button className="px-4 py-2 bg-lime-600 rounded hover:shadow-lg hover:opacity-85" onClick={saveBtnClick}
                                disabled={locationId === "" ? true : false}
                            >
                                <span>Gesek</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col mt-4 gap-4 sm:bg-white sm:shadow-md sm:border rounded-md sm:p-4">
                <div className="flex items-center gap-4">
                    <div>
                        <span>Show </span>
                    </div>
                    <div className="w-20">
                        <Dropdown options={PageSizeOptions} value={pageSize} onChange={pageSizeChange} />
                    </div>
                </div>

                {/* Desktop Size */}
                <div className="hidden sm:block overflow-auto">
                    <DataTable
                        columns={columns}
                        data={transactionList?.data?.listData ?? []}
                    />
                </div>
                
                {/* Mobile Size */}
                <div className="block sm:hidden overflow-auto">
                    <div className="flex flex-col gap-3">
                        {transactionList?.data?.listData?.map((data, i) => {
                            return(
                                <div className="flex flex-col bg-white border-b pb-3" key={i}>
                                    <div className="flex w-full justify-between">
                                        <div className="flex flex-col">
                                            <div className="flex flex-col">
                                                <label className="text-sm">{data.customerName}</label>
                                                <label className="text-sm">{data.cardNumber}</label>
                                                <label className="text-sm font-semibold">{"Rp " + money(String(Math.floor(data.amount)))}</label>
                                            </div>
                                        </div>
                                        <div className="flex flex-col text-right">
                                            <label className="text-sm">{moment(data.transactionDate).format("DD MMM yyyy")}</label>
                                            <label className="text-sm">{data.mdr}</label>
                                        </div>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <label>{data.edcBank + " - " + data.edcName}</label>
                                        <button className={`bg-black py-1 px-3 rounded-full flex gap-2`} onClick={() => deleteBtnClick(data.transactionId, data.status)}>
                                            <span className="text-xs text-white">Delete</span>
                                        </button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </MainBodyCard>
    )
}

const Card = ({ title, children, width = 'w-full sm:w-72' }) => {
    return(
        <div className="flex flex-col sm:flex-row sm:items-center">
            <div className="w-48 text-sm">
                <span>{title}</span>
            </div>
            <div className="px-2 hidden sm:block">
                <span>:</span>
            </div>
            <div className={width}>
                {children}
            </div>
        </div>
    )
}